
































import { CentralNotificacoesService } from "@/services/central-notificacao.service";
import { LoginService } from "@/services/login.service";
import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";

@Component
export default class Bar extends Vue {
  @Prop({ default: false }) readonly fixed!: boolean;
  @Prop({ default: false }) readonly desktop!: boolean;

  totalNaoLidos = 0;

  async mounted() {
    await this.atualizarContador();
  }
  onClick() {
    this.$emit("toggleMenu");
  }

  async sino() {
    await this.atualizarContador();
    this.$router.push({ name: "comentarios" });
  }

  async atualizarContador() {
    this.totalNaoLidos =
      await CentralNotificacoesService.contarComentariosNaoLidos();
  }

  sair() {
    LoginService.logOut().then(() => {
      this.$router.replace({ name: "login" });
    });
  }
}
